// extracted by mini-css-extract-plugin
module.exports = {"html":"index-module--html--2CzkS"};